import { render, staticRenderFns } from "./Geolocation.vue?vue&type=template&id=68ca9d0e&scoped=true"
import script from "./Geolocation.vue?vue&type=script&lang=js"
export * from "./Geolocation.vue?vue&type=script&lang=js"
import style0 from "./Geolocation.vue?vue&type=style&index=0&id=68ca9d0e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ca9d0e",
  null
  
)

export default component.exports